// extracted by mini-css-extract-plugin
export default {"list":"stageTabs_list__uyGqg","active":"stageTabs_active__qBsmK"};